import { FunctionComponent } from 'react';
import { useAppDispatch } from '../../../../../configuration/setup/hooks';
import { serviceOrdersSlice } from '../../../reducers/serviceOrdersSlice';
import { BulkSelectionDropdown } from '../../../sharedComponents/table/BulkSelectionDropdown';

export const SERVICE_ORDER_MAX_SELECTION_SIZE = 100;

export const ServiceOrderBulkSelectionDropdown: FunctionComponent = () => {
    const dispatch = useAppDispatch();

    const handleClearSelection = () => {
        dispatch(serviceOrdersSlice.actions.clearBulkSelection());
    };
    return (
        <BulkSelectionDropdown
            addFilterResultToSelection={async () => {}}
            removeFilterResultFromSelection={async () => {}}
            clearSelection={handleClearSelection}
            hasTooManyFilterResultsError={false}
            maxSelectionSize={SERVICE_ORDER_MAX_SELECTION_SIZE}
            resetTooManyFilterResultsError={() => {}}
        />
    );
};
